<script>
import { handleError } from "@/utils/error";
import util from "../util";
import { permissionMixin } from "@/mixins/permissions";

export default {
  mixins: [permissionMixin],
  data() {
    return {
      satcomTargetDialog: false,
      loading: false,
      isUpdateAPIKeyEnabled: false,
      urlRules: [v => this.validateURLField(v)],
      isAPIKeyHidden: true
    };
  },
  computed: {
    url: {
      get() {
        return this.$store.state.messagingLog.editedItem.url;
      },
      set(val) {
        this.$store.commit("messagingLog/updateSatcomTargetUrl", val);
      }
    },
    api_key: {
      get() {
        return this.$store.state.messagingLog.editedItem.api_key;
      },
      set(val) {
        this.$store.commit("messagingLog/updateSatcomTargetApiKey", val);
      }
    }
  },
  methods: {
    openSatcomTargetDialog() {
      this.satcomTargetDialog = true;
      this.fetchSatcomTarget();
    },
    closeSatcomTargetDialog() {
      this.satcomTargetDialog = false;
      this.$refs.setSatcomTargetForm.resetValidation();
      this.isUpdateAPIKeyEnabled = false;
      this.isAPIKeyHidden = true;
      this.$store.dispatch("messagingLog/clearSatcomTargetForm");
    },
    setSatcomTarget() {
      if (this.$refs.setSatcomTargetForm.validate()) {
        this.loading = true;
        let data = {
          url: this.url || null,
          api_key: this.api_key || null
        };
        this.$store
          .dispatch("messagingLog/setSatcomTarget", data)
          .then(() => {
            let data = {
              text: this.$t(
                "modules.logs.messagingLog.satcomTarget.successText"
              ),
              shown: true,
              color: "success",
              id: "apply-success"
            };
            this.$store.dispatch("snackbar/setMessage", data);
            this.satcomTargetDialog = false;
            this.isUpdateAPIKeyEnabled = false;
            this.isAPIKeyHidden = true;
          })
          .catch(error => {
            handleError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    fetchSatcomTarget() {
      this.$store.dispatch("messagingLog/fetchSatcomTarget").catch(error => {
        handleError(error);
      });
    },
    validateURLField(value) {
      if (value && !util.IP_REGEX.test(value) && !util.URL_REGEX.test(value)) {
        return this.$t("validation.invalid", [
          this.$t("modules.logs.messagingLog.satcomTarget.url")
        ]);
      }
      return true;
    }
  }
};
</script>

<template>
  <div>
    <v-dialog max-width="500" v-model="satcomTargetDialog">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          @click="openSatcomTargetDialog()"
          v-bind="attrs"
          v-on="on"
          :disabled="!isPermitted(PermissionEnum.APPLICATION_RULES.UPDATE)"
        >
          {{ $t("modules.logs.messagingLog.satcomTarget.title") }}
        </v-btn>
      </template>
      <v-card>
        <v-form ref="setSatcomTargetForm" @submit.prevent="setSatcomTarget()">
          <v-container>
            <v-card-title>
              {{ $t("modules.logs.messagingLog.satcomTarget.formTitle") }}
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="url"
                :label="$t('modules.logs.messagingLog.satcomTarget.url')"
                id="satcom-target__form-url"
                :rules="urlRules"
                autocomplete="off"
              ></v-text-field>
              <div class="d-flex align-center">
                <div class="pr-3 text-body-2">
                  {{
                    $t("modules.logs.messagingLog.satcomTarget.updateApiKey")
                  }}
                </div>
                <v-switch
                  id="satcom-target__update-api-key"
                  v-model="isUpdateAPIKeyEnabled"
                ></v-switch>
              </div>
              <v-text-field
                v-if="isUpdateAPIKeyEnabled"
                v-model="api_key"
                :label="$t('modules.logs.messagingLog.satcomTarget.apiKey')"
                id="satcom-target__form-api-key"
                autocomplete="off"
                :type="isAPIKeyHidden ? 'password' : 'text'"
                :append-icon="isAPIKeyHidden ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="isAPIKeyHidden = !isAPIKeyHidden"
              ></v-text-field>
            </v-card-text>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="closeSatcomTargetDialog()">
              {{ $t("actions.cancel") }}
            </v-btn>
            <v-btn
              color="secondary"
              type="submit"
              :loading="loading"
              id="satcom-target__form-add"
            >
              {{ $t("actions.save") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
